import FedericaLavoro from "../../../../images/content/introduction/applia-secretariat/FedericaLavoro.webp";
import MariaVittoriaSbrescia from "../../../../images/content/introduction/applia-secretariat/MariaVittoriaSbrescia.webp";
import MikelaMema from "../../../../images/content/introduction/applia-secretariat/MikelaMema.webp";

export const AppliaSecretariatMembersTeam2 = [
	{
		name: "Federica Lavoro",
		imageUrl: FedericaLavoro,
		background: "pages.introduction.appliaSecretariat.members.federicaLavoro.background",
		functionTitle: "pages.introduction.appliaSecretariat.members.federicaLavoro.functionTitle",
	},
	{
		name: "Maria Vittoria Sbrescia",
		imageUrl: MariaVittoriaSbrescia,
		background: "pages.introduction.appliaSecretariat.members.mariaVittoriaSbrescia.background",
		functionTitle: "pages.introduction.appliaSecretariat.members.mariaVittoriaSbrescia.functionTitle",
	},
	{
		name: "Mikela Mema",
		imageUrl: MikelaMema,
		background: "pages.introduction.appliaSecretariat.members.mikelaMema.background",
		functionTitle: "pages.introduction.appliaSecretariat.members.mikelaMema.functionTitle",
	},

];
